import { Injectable } from '@angular/core';
import { Observable} from 'rxjs/Rx';
import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { HttpParams } from '@angular/common/http/src/params';
import { environment } from "../../environments/environment";
import { error } from 'util';

@Injectable()
export class ApiService {

  constructor(private _http: HttpClient) { }

  private formatErrors(error: any) {
    console.log('formatErrors :', error);
    return Observable.throw(error.statusText);
  }

  put(api: string, path: string, body: Object = {}): Observable<any> {
    let endPointUrl = this.getEndPointUrl(api);
    return this._http.put(endPointUrl + path, body)
      .catch(this.formatErrors)
      .map((res: Response) => { return res; }
      );
  }

  post(api: string, path: string, body: Object = {}): Observable<any> {
    let endPointUrl = this.getEndPointUrl(api);
    return this._http.post(endPointUrl + path, body)
      .catch(this.formatErrors)
      .map((res: Response) => { return res }
      );
  }

  get(api: string, path: string, body: Object = {}): Observable<any> {
    let endPointUrl = this.getEndPointUrl(api);

    return this._http.get(endPointUrl + path, body)
      .catch(this.formatErrors)
      .map((res: Response) => { return res }
      );
  }

  getEndPointUrl(api = "") {
    let endPointUrl: string
    if (api == "")
      endPointUrl = environment.apiRootUrl;
    else if (api == "Auth")
      endPointUrl = environment.loginUrl;
    return endPointUrl;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/api.service.ts